// Image proxy/optimizer.
// Routes images through images.weserv.nl which: resizes to target width,
// converts to WebP when the browser supports it, and caches at the edge.
// Source images that are already small (Unsplash with ?w=) bypass the proxy.

const isOptimizable = (url) => {
  if (!url) return false;
  // Already small / pre-sized stock URLs — skip proxy
  if (url.startsWith("data:")) return false;
  if (url.startsWith("https://images.unsplash.com/")) return false;
  return /^https?:\/\//.test(url);
};

export const optimizeImg = (url, width = 1600, quality = 80) => {
  if (!isOptimizable(url)) return url;
  // weserv.nl expects a host-stripped URL, but it also accepts full URL via "url" param.
  // We pass URL without protocol to keep the query short.
  const stripped = url.replace(/^https?:\/\//, "");
  const params = new URLSearchParams({
    url: stripped,
    w: String(width),
    q: String(quality),
    output: "webp",
  });
  return `https://images.weserv.nl/?${params.toString()}`;
};
